"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_1 = require("gatsby");
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
var Header = function Header(_ref) {
    var _ref$avatar = _ref.avatar, avatar = _ref$avatar === void 0 ? '' : _ref$avatar;
    return /*#__PURE__*/ react_1.default.createElement("header", {
        className: "logo"
    }, /*#__PURE__*/ react_1.default.createElement(router_1.Location, null, function (_ref2) {
        var location = _ref2.location;
        return location.pathname == "/" ? /*#__PURE__*/ react_1.default.createElement("div", null, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
            to: "/about/"
        }, /*#__PURE__*/ react_1.default.createElement("img", {
            src: avatar,
            className: "logo-avatar"
        })), /*#__PURE__*/ react_1.default.createElement("span", {
            className: "logo-prompt code"
        }, "About the Author")) : /*#__PURE__*/ react_1.default.createElement("div", null, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
            to: "/"
        }, /*#__PURE__*/ react_1.default.createElement("img", {
            src: avatar,
            className: "logo-avatar"
        })), /*#__PURE__*/ react_1.default.createElement("span", {
            className: "logo-prompt code"
        }, "Back Home"));
    }));
};
exports.default = Header;
